import React from 'react';

import { getDiscountVerificationInfo, redirectToDiscountVerification } from './actions';
import * as VerificationConstants from './constants';
import * as D from './deps';
import Reducer from './reducer';
import VerificationSagas from './sagas/watchers';
import {
  getDiscountVerificationDiscountType,
  getIsDiscountPaymentPageReady,
  isDiscountVerificationInfoLoaded,
  isDiscountVerificationStatusVerified,
  isInStudentReverificationPeriod,
  isStudentReverificationDenied4Year,
} from './selectors';
import { getVerificationTypeFromDiscountType } from './utils';

export default D.createDomainModule({
  name: VerificationConstants.DOMAIN_NAME,
  actions: {
    _verification_: {
      redirectToDiscountVerification,
      getDiscountVerificationInfo,
    },
  },
  components: {
    Verification: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_verification_verification" */ './components/Verification/Verification',
            )
          }
        />
      );
    },
    ReverificationCongratulationsPage: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_verification_reverification-congratulations-page" */ './components/ReverificationCongratulationsPage/ReverificationCongratulationsPage',
            )
          }
        />
      );
    },
  },
  reducer: Reducer,
  selectors: {
    _verification_: {
      getIsDiscountPaymentPageReady,
      isDiscountVerificationStatusVerified,
      isDiscountVerificationInfoLoaded,
      getDiscountVerificationDiscountType,
      isInStudentReverificationPeriod,
      isStudentReverificationDenied4Year,
    },
  },
  utils: {
    _verification_: { getVerificationTypeFromDiscountType },
  },
  onStart() {
    this.registeredHandlers = D.registerHandlers(VerificationSagas);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
